import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const EmployeeRoute = ({ children }) => {
    const { employee, loading } = useAuth();
    const hasToken = Boolean(localStorage.getItem("employee_token"));

    if (loading && hasToken) return children;

    if (loading) return <div className="min-h-screen bg-[var(--bg-primary)]" />;

    if (!employee) return <Navigate to="/login" />;

    return children;
};

export default EmployeeRoute;
